<!-- Button -->
<button
  mat-icon-button
  [matMenuTriggerFor]="userActions">
  <span class="relative">
    @if (showAvatar && user.profileImage) {
      <img
        class="w-7 h-7 rounded-full"
        [src]="getUserImageUrl()">
    }
    @if (!showAvatar || !user.profileImage) {
      <mat-icon
      [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
    }
  </span>
</button>

<mat-menu
  [xPosition]="'before'"
  #userActions="matMenu">
  <button mat-menu-item>
    <span class="flex flex-col leading-none">
      <span>{{ 'signedInAs' | transloco }}</span>
      <span class="mt-1.5 text-md font-medium">{{ user.displayName }}</span>
    </span>
  </button>
  <mat-divider class="my-2"></mat-divider>
  <button mat-menu-item (click)="signOut()">
    <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
    <span>{{ 'signOut' | transloco }}</span>
  </button>
</mat-menu>
